module.exports = __webpack_public_path__ + "img/vessel_select.1b28f616.svg";